import { SubscriptionPreference } from "../models/subscription-preference";

export class SubscriptionCenterService {
    private static endpoint = '/apic/subscriptioncenter';

    public getPreferences = async (): Promise<SubscriptionPreference[]> => {
        const response = await fetch(SubscriptionCenterService.endpoint, {
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            method: 'GET'
        });
        return (await response.json() as any[]).map(SubscriptionPreference.fromJson);
    };

    public setPreferences = async (preferences: SubscriptionPreference[]): Promise<void> => {
        await fetch(SubscriptionCenterService.endpoint, {
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            method: 'PUT',
            body: JSON.stringify(preferences)
        });
    };
}
